import { useToken } from "@rentablo/api";
import { OauthParamsGrantTypeEnum } from "@rentablo/api/apiv1";
import { useSessionLogin } from "../useSessionLogin/useSessionLogin";
import { useRememberMe } from "./useRememberMe";

export const useTwoLogins = ({
  shouldUpdateQuery = true,
}: { shouldUpdateQuery?: boolean } = {}) => {
  const { getTokenAsync, getTokenQuery } = useToken({
    shouldUpdateQuery,
  });

  const {
    mutateAsync: sessionLoginAsync,
    isPending: isSessionLoginPending,
    isSuccess: isSessionLoginSuccess,
  } = useSessionLogin();

  const [, setRememberMe] = useRememberMe();

  const loginAsync = async (attrs: {
    username: string;
    password: string;
    rememberMe?: boolean;
    grant_type?: OauthParamsGrantTypeEnum;
    mfa_challenge_code?: number;
    mfa_secret?: string;
  }) => {
    const result = await getTokenAsync({
      ...attrs,
      grant_type: attrs.grant_type ?? "password",
    });

    if (
      (attrs.grant_type === "password" ||
        attrs.grant_type === "two_factor_authentication") &&
      attrs.rememberMe !== undefined &&
      result.access_token
    ) {
      setRememberMe(attrs.rememberMe);
    }

    await sessionLoginAsync({
      email: attrs.username,
      ...attrs,
    });
    return result;
  };

  return {
    loginAsync,
    isFetching: getTokenQuery.isPending || isSessionLoginPending,
    isSuccess: getTokenQuery.isSuccess && isSessionLoginSuccess,
    tokenError: getTokenQuery.error?.response as Partial<ApiException> & {
      status: number;
    },
  };
};
